import axios from 'axios';

import constants from '../constants.js';

export const readQuestionnaire = async ({ id, cultureCode }) => {
    const res = await axios({
        method: constants.api.questionnaire.read.method,
        url: constants.api.questionnaire.read.endpoint
            .replace(constants.api.parameters.questionaireId, id),
        params: { cultureCode: cultureCode },
    });
    return res.data;
};

export const createResponse = async ({ questionnaireId, cultureCode }) => {
    const res = await axios({
        method: constants.api.response.create.method,
        url: constants.api.response.create.endpoint
            .replace(constants.api.parameters.questionaireId, questionnaireId),
        params: { cultureCode: cultureCode },
    });
    return res.data;
};

export const readResponse = async ({ questionnaireId, responseId }) => {
    const res = await axios({
        method: constants.api.response.read.method,
        url: constants.api.response.read.endpoint
            .replace(constants.api.parameters.questionaireId, questionnaireId)
            .replace(constants.api.parameters.responseId, responseId),
    });
    return res.data;
}

export const updateResponse = async ({ questionnaireId, responseId, questionId, optionValues }) => {
    const res = await axios({
        method: constants.api.response.update.method,
        url: constants.api.response.update.endpoint
            .replace(constants.api.parameters.questionaireId, questionnaireId)
            .replace(constants.api.parameters.responseId, responseId),
        data: {
            QuestionId: questionId,
            OptionValues: optionValues,
        },
    });
    return res.data;
}

export const finishResponse = async ({ questionnaireId, responseId }) => {
    const res = await axios({
        method: constants.api.response.update.method,
        url: constants.api.response.update.endpointFinish
            .replace(constants.api.parameters.questionaireId, questionnaireId)
            .replace(constants.api.parameters.responseId, responseId),
    });
    return res.data;
}
